import { render, staticRenderFns } from "./TarifaCadastro.vue?vue&type=template&id=443a8d38&scoped=true&"
import script from "./TarifaCadastro.vue?vue&type=script&lang=js&"
export * from "./TarifaCadastro.vue?vue&type=script&lang=js&"
import style0 from "./TarifaCadastro.vue?vue&type=style&index=0&id=443a8d38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443a8d38",
  null
  
)

export default component.exports